import { useEffect, useState } from "react";
import { breakpoints } from "../utils/styles";

type BreakpointsState = Record<keyof typeof breakpoints, boolean>;

export function useBreakpoints(): BreakpointsState {
    const [matches, setMatches] = useState<BreakpointsState>(() =>
        Object.keys(breakpoints).reduce((acc, key) => {
            acc[key as keyof typeof breakpoints] = false;
            return acc;
        }, {} as BreakpointsState)
    );

    useEffect(() => {
        if (typeof window === "undefined") return;

        const mediaQueries = Object.entries(breakpoints).map(([key, width]) => {
            const mql = window.matchMedia(`(min-width: ${width}px)`);

            const update = () =>
                setMatches((prev) => ({
                    ...prev,
                    [key]: mql.matches,
                }));

            update();

            mql.addEventListener("change", update);
            return { key, mql, update };
        });

        return () => {
            mediaQueries.forEach(({ mql, update }) => {
                mql.removeEventListener("change", update);
            });
        };
    }, []);

    return matches;
}